(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["furmosa-campaign-results"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('furmosa-results')) {
    customElements.define('furmosa-results', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        const opts = { signal: this.abort.signal };
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.dots = [...this.querySelectorAll('[data-dot]')];
        this.current = 0;
        this.hovered = false;
        this.focused = false;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
        this.region = this.querySelector('.fm-results__carousel');
        this.track = this.querySelector('.fm-results__slides');
        this.toggle = this.querySelector('[data-pause]');
        this.dialog = this.querySelector('dialog');
        this.opener = this.querySelector('[data-donation-open]');
        this.querySelector('.fm-results__controls')?.removeAttribute('hidden');
        this.querySelector('[data-prev]')?.addEventListener('click', () => this.show(this.current - 1, true), opts);
        this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.current + 1, true), opts);
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.show(i, true), opts));
        this.toggle?.addEventListener('click', () => { this.paused = !this.paused; this.sync(); }, opts);
        this.region.addEventListener('mouseenter', () => { this.hovered = true; this.sync(); }, opts);
        this.region.addEventListener('mouseleave', () => { this.hovered = false; this.sync(); }, opts);
        this.region.addEventListener('focusin', () => { this.focused = true; this.sync(); }, opts);
        this.region.addEventListener('focusout', event => { if (!this.region.contains(event.relatedTarget)) { this.focused = false; this.sync(); } }, opts);
        this.region.addEventListener('keydown', event => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault(); this.show(this.current + (event.key === 'ArrowLeft' ? -1 : 1), true);
          }
        }, opts);
        document.addEventListener('visibilitychange', () => this.sync(), opts);
        this.motion.addEventListener('change', () => { if (this.motion.matches) this.paused = true; this.sync(); }, opts);
        this.addEventListener('shopify:block:select', event => { const i = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId); if (i >= 0) this.show(i, true); }, opts);
        this.opener.addEventListener('click', () => { this.dialog.showModal(); this.sync(); }, opts);
        this.querySelector('[data-donation-close]').addEventListener('click', () => this.dialog.close(), opts);
        this.dialog.addEventListener('close', () => { this.opener.focus(); this.sync(); }, opts);
        this.dialog.addEventListener('click', event => { if (event.target === this.dialog) { const box = this.dialog.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close(); } }, opts);
        this.reveal = this.querySelector('.fm-results__reveal');
        const scheduleReveal = () => {
          if (this.revealFrame) return;
          this.revealFrame = requestAnimationFrame(() => {
            this.revealFrame = null;
            this.updateReveal();
          });
        };
        window.addEventListener('scroll', scheduleReveal, { ...opts, passive: true });
        window.addEventListener('resize', scheduleReveal, opts);
        this.motion.addEventListener('change', scheduleReveal, opts);
        this.updateReveal();
        this.show(0);
      }
      updateReveal() {
        if (!this.reveal) return;
        const mobile = window.innerWidth < 800;
        const track = this.querySelector(mobile ? '.fm-results__visual' : '.fm-results__scene-track');
        const distance = this.motion.matches ? 0 : window.innerHeight * 0.8 + this.reveal.getBoundingClientRect().height * 0.2;
        this.style.setProperty('--pin-distance', distance + 'px');
        const origin = track.getBoundingClientRect().top + window.scrollY;
        const pinTop = mobile ? 80 : Math.min(origin, 140);
        this.style.setProperty('--scene-top', pinTop + 'px');
        const start = origin - pinTop;
        const progress = this.motion.matches ? 1 : Math.max(0, Math.min(1, (window.scrollY - start) / distance));
        this.style.setProperty('--pin-remaining', (distance * (1 - progress)).toFixed(2) + 'px');
        this.reveal.style.setProperty('--reveal', (progress * 100).toFixed(2) + '%');
      }
      show(index, manual = false) {
        if (!this.slides.length) return;
        if (manual) this.paused = true;
        this.current = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => { slide.hidden = i !== this.current; });
        this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.current)));
        this.sync();
      }
      sync() {
        clearInterval(this.timer);
        if (!this.toggle) return;
        this.toggle.textContent = this.paused ? '▶' : 'Ⅱ';
        this.toggle.setAttribute('aria-label', this.paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel);
        const running = !this.paused && !this.hovered && !this.focused && !document.hidden && !this.dialog.open;
        this.track.setAttribute('aria-live', running ? 'off' : 'polite');
        if (running && this.slides.length > 1) this.timer = setInterval(() => this.show(this.current + 1), Number(this.dataset.interval) || 6000);
      }
      disconnectedCallback() { cancelAnimationFrame(this.revealFrame); this.revealFrame = null; clearInterval(this.timer); this.abort?.abort(); this.abort = null; }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
